const DB_NAME = 'mapadecasosdb';
const DB_VERSION = 1;
let DB;

const getDb = async () => new Promise((resolve, reject) => {
  if (DB) {
    resolve(DB);
  }
  const request = window.indexedDB.open(DB_NAME, DB_VERSION);

  request.onerror = () => {
    reject(new Error('Error'));
  };

  request.onsuccess = (e) => {
    DB = e.target.result;
    resolve(DB);
  };

  request.onupgradeneeded = (e) => {
    const db = e.target.result;
    db.createObjectStore('mapaDeCasos', {
      autoIncrement: true,
      keyPath: 'id',
    });
    db.createObjectStore('mapaDeAjuda', {
      autoIncrement: true,
      keyPath: 'id',
    });
    db.createObjectStore('usuariosMural', {
      autoIncrement: true,
      keyPath: 'id',
    });
    resolve(DB);
  };
});

const getMapaDeCasos = async () => {
  const db = await getDb();

  return new Promise((resolve) => {
    const mapaDeCasos = [];

    const trans = db.transaction(['mapaDeCasos'], 'readonly');
    trans.oncomplete = () => {
      resolve(mapaDeCasos);
    };

    const store = trans.objectStore('mapaDeCasos');

    store.openCursor().onsuccess = (e) => {
      const cursor = e.target.result;
      if (cursor) {
        mapaDeCasos.push(cursor.value);
        cursor.continue();
      }
    };
  });
};

const saveMapaDeCasos = async (mapaDeCasos) => {
  const db = await getDb();

  return new Promise((resolve) => {
    const trans = db.transaction(['mapaDeCasos'], 'readwrite');

    Object.values(mapaDeCasos).forEach((item) => {
      const store = trans.objectStore('mapaDeCasos');
      store.add(item);
    });

    trans.oncomplete = () => {
      resolve();
    };
  });
};

const getMapaDeAjuda = async () => {
  const db = await getDb();

  return new Promise((resolve) => {
    const mapaDeAjuda = [];

    const trans = db.transaction(['mapaDeAjuda'], 'readonly');
    trans.oncomplete = () => {
      resolve(mapaDeAjuda);
    };

    const store = trans.objectStore('mapaDeAjuda');
    store.openCursor().onsuccess = (e) => {
      const cursor = e.target.result;
      if (cursor) {
        mapaDeAjuda.push(cursor.value);
        cursor.continue();
      }
    };
  });
};

const saveMapaDeAjuda = async (mapaDeAjuda) => {
  const db = await getDb();

  return new Promise((resolve) => {
    const trans = db.transaction(['mapaDeAjuda'], 'readwrite');

    Object.values(mapaDeAjuda).forEach((item) => {
      const store = trans.objectStore('mapaDeAjuda');
      store.add(item);
    });

    trans.oncomplete = () => {
      resolve();
    };
  });
};

const getMural = async () => {
  const db = await getDb();

  return new Promise((resolve) => {
    const usuariosMural = [];

    const trans = db.transaction(['usuariosMural'], 'readonly');
    trans.oncomplete = () => {
      resolve(usuariosMural);
    };

    const store = trans.objectStore('usuariosMural');

    store.openCursor().onsuccess = (e) => {
      const cursor = e.target.result;
      if (cursor) {
        usuariosMural.push(cursor.value);
        cursor.continue();
      }
    };
  });
};

const saveMural = async (usuariosMural) => {
  const db = await getDb();

  return new Promise((resolve) => {
    const trans = db.transaction(['usuariosMural'], 'readwrite');

    Object.values(usuariosMural).forEach((item) => {
      const store = trans.objectStore('usuariosMural');
      store.add(item);
    });

    trans.oncomplete = () => {
      resolve();
    };
  });
};

export default {
  getDb,
  getMapaDeCasos,
  saveMapaDeCasos,
  getMapaDeAjuda,
  saveMapaDeAjuda,
  getMural,
  saveMural,
};
